import React from "react";
import { Card, CardBody } from "reactstrap";

import "./style.scss";
import { MUIIcons } from "../../AbstractElements";
import FileHandler from "../../CommonElements/FileHandler";
import InstanceFilePreviewer from "../../CommonElements/FileHandler/InstanceFileLoader";

interface UploadedFileItemProps {
  fileName: string;
  thumbnailUrl: any;
  onDelete: () => void;
  showDeleteIcon?: boolean;
}

const UploadedFileItem: React.FC<UploadedFileItemProps> = ({
  fileName,
  thumbnailUrl,
  showDeleteIcon = true,
  onDelete,
}) => {
  return (
    <Card className="uploaded-file-card">
      <CardBody className="uploaded-file-body d-flex align-items-center">
        <img
          src={
            thumbnailUrl instanceof File
              ? URL.createObjectURL(thumbnailUrl)
              : thumbnailUrl
          }
          alt={fileName}
          className="uploaded-file-thumbnail"
        />
        <div className="uploaded-file-info flex-grow-1 ms-2">
          <span className="uploaded-file-name">
            {thumbnailUrl instanceof File ? (
              <InstanceFilePreviewer file={thumbnailUrl} />
            ) : (
              <FileHandler mediaUrl={thumbnailUrl} />
            )}
          </span>
        </div>
        {showDeleteIcon && (
          <MUIIcons
            className="uploaded-file-delete-icon primary-icon-color"
            onClick={onDelete}
            iconName="Delete"
            size={18}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default UploadedFileItem;
